import { useState, useEffect, useCallback } from 'react';

export function useNumberInput(
  number?: number,
  setNumber?: (value?: number) => void,
  allowNegative?: boolean
) {
  // Inputs need to be text based
  const [textInput, setTextInput] = useState(number?.toString() ?? '');

  // Number cleaning built in
  const handleChangeTextInput = useCallback(
    (textInput?: string) => {
      if (allowNegative) {
        setTextInput(textInput?.replace(/[^-?(0|[1-9]\d+$]+/g, '') ?? '');
      } else {
        setTextInput(textInput?.replace(/[^(0|[1-9]\d+$]+/g, '') ?? '');
      }
    },
    [allowNegative]
  );

  // Update text value if external number has changed
  useEffect(() => {
    if (number?.toString() !== textInput) {
      setTextInput(textInput?.toString() ?? '');
    }
  }, [number]);

  // Update number value when the text
  useEffect(() => {
    if (textInput.length === 0 && number !== undefined) {
      setNumber && setNumber(undefined);
      return;
    }
    if (textInput.length > 0 && !isNaN(+textInput) && +textInput != number) {
      setNumber && setNumber(+textInput);
      return;
    }
    if (textInput === '-' && number !== undefined) {
      setNumber && setNumber(undefined);
    }
  }, [textInput]);

  return {
    textInput,
    handleChangeTextInput,
  };
}
